import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-white to-orange-50" data-id="element-86">
      <div className="max-w-4xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-88">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-89">
            ¿Y si un día mamá ya no está... y nunca le preguntaste su historia?
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-90">
            <p data-id="element-91">
              El tiempo pasa más rápido de lo que creemos. Y con él, se van las
              voces, los recuerdos, las historias que nunca volverán.
            </p>
            <p data-id="element-92">
              Cuando mamá te cuenta una anécdota de su infancia, de cómo conoció
              a tu papá, de aquella época que ya no existe... sentís algo en el
              pecho.
            </p>
            <p data-id="element-93">
              Una mezcla de nostalgia, amor y miedo. Miedo a que un día esas
              historias se pierdan para siempre.
            </p>
            <p className="font-semibold text-xl text-[#1A1A1A]" data-id="element-94">
              Porque la realidad es esta: el tiempo no espera.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}